import { useState } from "react";
import { Link } from "react-router-dom";
import { FileCheck2, Loader2, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { trpc } from "@/lib/trpc";
import { LEGAL_VERSION } from "../../../shared/legal";

export default function LegalConsent() {
  const [accepted, setAccepted] = useState(false);
  const utils = trpc.useUtils();
  const acceptMutation = trpc.users.acceptLegalTerms.useMutation({
    onSuccess: async () => {
      await utils.auth.me.invalidate();
    },
  });

  return (
    <div className="min-h-screen bg-background px-4 py-8 flex items-center justify-center">
      <Card className="w-full max-w-lg border-border/70 shadow-lg">
        <CardHeader className="text-center space-y-3">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary"><ShieldCheck className="h-6 w-6" /></div>
          <CardTitle className="font-serif text-2xl">Antes de continuar</CardTitle>
          <CardDescription className="leading-relaxed">Atualizamos os documentos que explicam como o Bolso funciona e como tratamos os dados que você registra.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-5">
          <div className="rounded-xl border bg-muted/30 p-4 text-sm leading-relaxed text-muted-foreground">
            <div className="flex gap-2"><FileCheck2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" /><p>O Bolso organiza informações financeiras inseridas por você. Não se conecta a bancos, não pede senha bancária e não movimenta dinheiro.</p></div>
          </div>
          <label className="flex cursor-pointer items-start gap-3 rounded-xl border p-4 text-sm leading-relaxed hover:bg-muted/30">
            <input type="checkbox" checked={accepted} onChange={(event) => setAccepted(event.target.checked)} className="mt-1 h-4 w-4 accent-primary" />
            <span>Li e aceito os <Link className="font-medium text-primary underline underline-offset-2" target="_blank" to="/termos-de-uso">Termos de Uso</Link> e declaro estar ciente da <Link className="font-medium text-primary underline underline-offset-2" target="_blank" to="/politica-de-privacidade">Política de Privacidade</Link>.</span>
          </label>
          {acceptMutation.isError && <p className="text-sm text-destructive">Não foi possível registrar seu aceite. Tente novamente.</p>}
          <Button className="w-full" disabled={!accepted || acceptMutation.isPending} onClick={() => acceptMutation.mutate({ version: LEGAL_VERSION })}>
            {acceptMutation.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Continuar para o Bolso
          </Button>
          <p className="text-center text-xs text-muted-foreground">Versão dos documentos: {LEGAL_VERSION}</p>
        </CardContent>
      </Card>
    </div>
  );
}
